import { ReportDescriptionItem as _ReportDescriptionItem } from '@team-milva/lab-models/resources'

export class ReportDescriptionItem extends _ReportDescriptionItem {}
